module.exports = __webpack_public_path__ + "img/ORDER-LIVE.9f26afc3.png";